import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-no-data-view',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './no-data-view.component.html',
    styleUrl: './no-data-view.component.css'
})
export class NoDataViewComponent {
  @Input() imageHeight: any;
  @Input() title: string = 'No Records Found';
  @Input() description: string = 'There are currently no records available to display';
  @Input() imagePath: string = './assets/media/icons/no-data-eva.png';
  // imageHeight: string = '230px';
}
